/**
 * When React renders custom elements, it assumes all attributes are
 * string-ish. When setting a bool attribute value to `false`, it will
 * coerce it into "false," which hasAttribute evaluates to true.
 *
 * By passing `null` instead, React will not add the attribute at all,
 * which is correct. This function coerces the input to get the
 * behavior you'd expect.
 *
 * See https://github.com/facebook/react/issues/9230#issuecomment-1094149596
 */
export default function customElementBoolAttr(value: any) {
  return value ? true : null;
}
